<template>
  <Heading
    :title="this.title"
    :header="this.header"
    :headerColor="this.headerColor"
    :wave="this.wave"
    :divider="this.divider"
    :icon="this.icon"
    tag="h3"
    v-bind="$attrs"
  >
    <template #subtitle v-if="shouldRenderSlot">
      <div class="mt-4">
        <h4 :class="subtitleClass" v-if="hasSubtitle">
          <slot name="subtitle">
            {{ subtitle }}
          </slot>
        </h4>
        <slot name="description">
          <Row no-gutters v-if="hasDescription">
            <Col cols="8 col-md-6">
              <span :class="descriptionClass" v-text="description" />
            </Col>
          </Row>
        </slot>
      </div>
    </template>
  </Heading>
</template>
<script>
import { Heading, Row, Col } from '@locaweb/design-system-vue'

export default {
  name: 'PanelHeading',
  components: {
    Heading,
    Row,
    Col
  },
  inheritAttrs: false,
  props: {
    title: String,
    subtitle: String,
    description: String,
    // Heading props
    header: Boolean,
    headerColor: String,
    wave: Boolean,
    divider: Boolean,
    icon: String
  },
  computed: {
    requiresWhiteText () {
      return ['primary', 'secondary', 'dark'].includes(this.headerColor)
    },
    subtitleClass () {
      return {
        'text-h4 font-weight-regular': true,
        'shade-white--text': this.requiresWhiteText
      }
    },
    descriptionClass () {
      return {
        'text-paragraph-2 font-weight-regular': true,
        'shade-white--text': this.requiresWhiteText
      }
    },
    hasSubtitle () {
      return this.$slots.subtitle || this.subtitle
    },
    hasDescription () {
      return this.$slots.description || this.description
    },
    shouldRenderSlot () {
      return this.hasSubtitle || this.hasDescription
    }
  }
}
</script>
